import { render, staticRenderFns } from "./UserActionResetPassword.vue?vue&type=template&id=4eb35e74&"
import script from "./UserActionResetPassword.vue?vue&type=script&lang=ts&"
export * from "./UserActionResetPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports